export default class BulkBlockedNumberService {
  /** @ngInject **/
  constructor(
    $http,
    $q,
    ngAuthSettings,
    cacheService
  ) {
    this.$http = $http;
    this.$q = $q;
    this.ngAuthSettings = ngAuthSettings;
    this.cacheService = cacheService;
  }


  searchBulkBlockedNumber(accountId, blockedNumber) {
    const urlParams = 'search?e164Number=%2b' + blockedNumber.substr(1);
    return this.$http.get(this.#getBaseUrl(accountId) + urlParams).then((response) =>{
      return response.data.result;
    });
  }

  unBlockBulkBlockedNumber(accountId, blockedNumber, deleteType, campaignId) {
    let urlParams = 'number/?E164Number=%2B' + blockedNumber.substr(1) + '&deleteType=' + deleteType;
    if (deleteType === 'Campaign') {
      urlParams = urlParams + '&CampaignId=' + campaignId;
    }
    return this.$http.delete(this.#getBaseUrl(accountId) + urlParams).then((response) =>{
      return response.data.exists;
    });
  }

  uploadBulkBlockedNumbers(accountId, listToBlockString, campaignId ) {
    const postBody = { Replace: false, E164_CSV_List: listToBlockString, campaignId };
    return this.$http.post(this.#getBaseUrl(accountId), postBody);
  }

  #getBaseUrl(accountId) {
    return this.ngAuthSettings.apiServiceBaseUri + accountId + '/bulkBlockedNumbers/';
  }

}
